export default "__VITE_ASSET__DXOYSnPo__"